<template>
  <div class="rect-line" ref="rectLine"></div>
</template>
<script>
import zrender from 'zrender'
export default {
  mounted() {
    let boxDom = this.$refs.rectLine
    Object.assign(boxDom.style, this.boxStyle)
    this.draw()
  },
  props: ['box-style', 'points'],
  methods: {
    draw() {
      let me = this
//[[100, 50], [100, 1230], [2000, 1230], [2000, 50],[100,50]]
      let zr = zrender.init(me.$refs.rectLine)
      let rectLine = new zrender.Polyline({
        shape: {
          points:me.points
        },
        style: {
          lineDash: [10, 300],
          stroke: '#818ab2',
          lineWidth: 10,
           blend: 'lighter',
        }
      })

      
      var polylineBase = new zrender.Polyline({
        shape: {
          // smooth: 0.6,
         points:me.points
        },
        style: {
          fill: 'none',
         
          lineDash: [10, 30],
          stroke: '#818ab2',
          opacity: 0.2,
          //  blend: 'multiply',
          lineWidth: 10
        }
      })

      //zr.add(polylineBase)
      zr.add(rectLine)
      // var polyline = new zrender.Polyline({
      //   shape: {
      //     // smooth: 0.3,
      //     points: [...me.points]
      //   },
      //   style: {
      //     fill: 'none',
      //     blend: 'lighter',
      //     stroke: 'rgb(100,230,230)',
      //     lineDash: [30, 470],
      //     shadowBlur: 50,
      //     shadowColor: 'rgb(0,255,254,.8)',
      //     opacity: 1,
      //     lineWidth: 14,
      //     blend: 'lighter'
      //   }
      // })

      // zr.add(polyline)

      rectLine
        .animate('style', true)
        .when(1000, { lineDashOffset: 1000 })
        .start()

      zr.configLayer(0, {
        motionBlur: true,
        lastFrameAlpha: 0.8
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.rect-line {
  position: absolute;
  // border:1px solid red;
  // z-index: 9999;
}
</style>




// WEBPACK FOOTER //
// src/components/shapes/rectLine.vue